<template>
  <div class="news_comment_operation " v-bind:class="{ news_comment_operation_new: isDetail == 3 }">
    <div v-if="isDetail == 30000000" class="news_comment_operation_3">
      <!--      -->
      <svg @click="clickShowPopover()" class="message" viewBox="0 0 1194 1024" version="1.1"
           xmlns="http://www.w3.org/2000/svg" width="37.3125"
           height="32"
           xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs></defs>
        <path
          d="M333.824 509.496889c32.369778 0 58.595556-25.486222 58.595556-56.888889 0-31.459556-26.225778-56.888889-58.595556-56.888889-32.312889 0-58.538667 25.429333-58.538667 56.888889 0 31.402667 26.168889 56.888889 58.595556 56.888889zM599.324444 509.496889c32.369778 0 58.595556-25.486222 58.595556-56.888889 0-31.459556-26.225778-56.888889-58.595556-56.888889-32.312889 0-58.595556 25.429333-58.595555 56.888889 0 31.402667 26.282667 56.888889 58.595555 56.888889zM864.824889 509.496889c32.312889 0 58.595556-25.486222 58.595555-56.888889 0-31.459556-26.282667-56.888889-58.595555-56.888889-32.369778 0-58.595556 25.429333-58.595556 56.888889 0 31.402667 26.225778 56.888889 58.595556 56.888889z"></path>
        <path
          d="M691.484444 844.003556a138.808889 138.808889 0 0 1 98.360889-40.846223h247.011556a55.751111 55.751111 0 0 0 55.751111-55.751111V184.547556a55.751111 55.751111 0 0 0-55.751111-55.751112H167.992889a55.751111 55.751111 0 0 0-55.751111 55.751112v562.858666c0 30.776889 24.917333 55.751111 55.751111 55.751111h246.044444a138.808889 138.808889 0 0 1 95.345778 37.944889l95.288889 90.112 86.812444-87.210666zM167.992889 54.840889h868.864a129.706667 129.706667 0 0 1 129.706667 129.706667v562.858666a129.706667 129.706667 0 0 1-129.706667 129.706667h-247.011556c-17.237333 0-33.792 6.826667-45.966222 19.114667l-93.070222 93.468444a64.853333 64.853333 0 0 1-90.510222 1.365333L458.581333 894.862222a64.853333 64.853333 0 0 0-44.544-17.749333H167.992889a129.706667 129.706667 0 0 1-129.706667-129.706667V184.547556a129.706667 129.706667 0 0 1 129.706667-129.706667z"></path>
      </svg>
      <span class="news_comment_praise_count" :class="'no_news_comment_praise_count_discuss_' + item.commentID"
            v-show="item.commentCount && item.commentCount>0">{{item.commentCount|parseCount}}</span>

      <svg @click="clickPares(item.curClass == 'news_comment_praise_img_active'? '' : item,1)"
           class="news_comment_praise_img list-praise"
           :class="item.curClass" version="1.1"
           xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
           y="0px"
           viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                 <g>
                                      <path d="M29.2,10.5c-1.2-0.3-4.2-0.3-8.5-0.4c0.2-0.9,0.2-1.8,0.2-3.3C20.9,3.2,18.3,0,16,0c-1.6,0-3,1.3-3,3
                                          c0,2-0.6,5.5-4,7.3c-0.2,0.1-1,0.5-1.1,0.5H8C7.5,10.3,6.7,10,6,10H3c-1.7,0-3,1.3-3,3v16c0,1.7,1.3,3,3,3h3c1.2,0,2.2-0.7,2.7-1.7
                                          l0,0c0.1,0,0.1,0,0.2,0.1l0,0c0.6,0.1,1.7,0.4,4.1,1c0.5,0.1,3.2,0.7,6,0.7h5.5c1.7,0,2.9-0.6,3.6-1.9c0,0,0.2-0.5,0.4-1.1
                                          c0.1-0.5,0.2-1.1,0-1.8c1.1-0.7,1.4-1.9,1.6-2.6c0.4-1.2,0.3-2.1,0-2.7c0.6-0.6,1.1-1.4,1.3-2.8c0.1-0.8,0-1.7-0.4-2.4
                                          c0.6-0.6,0.8-1.4,0.9-2.2v-0.2c0-0.1,0-0.2,0-0.5C32,12.6,31.1,11,29.2,10.5z M7,29c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V13
                                          c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1V29z M30,14.5c0,0.5-0.2,1.5-2,1.5c-1.5,0-2,0-2,0c-0.3,0-0.5,0.2-0.5,0.5S25.7,17,26,17
                                          c0,0,0.4,0,1.9,0s1.7,1.2,1.6,1.8C29.4,19.5,29,21,27.3,21s-2.4,0-2.4,0c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5c0,0,1.2,0,2,0
                                          c1.7,0,1.5,1.3,1.3,2.1c-0.3,1-0.5,1.9-2.6,1.9c-0.7,0-1.6,0-1.6,0c-0.3,0-0.5,0.2-0.5,0.5S23.7,27,24,27c0,0,0.7,0,1.6,0
                                          c1.1,0,1.1,1,1,1.4s-0.3,0.7-0.3,0.7C26,29.7,25.5,30,24.5,30H19c-2.7,0-5.5-0.6-5.5-0.6c-4.2-1-4.4-1-4.6-1.1c0,0-0.8-0.1-0.8-0.9
                                          V13.6c0-0.5,0.3-0.9,0.8-1c0.1,0,0.1,0,0.2-0.1c4.6-1.9,6-6,6-9.4c0-0.5,0.4-1,1-1c1.1,0,2.9,2.1,2.9,4.7c0,2.4-0.1,2.8-0.9,5.3
                                          c10,0,9.9,0.1,10.8,0.4c1.1,0.3,1.2,1.2,1.2,1.5C30,14.2,30,14.2,30,14.5z M32,32H0H32V0V32z"/>
                                  </g>
          </svg>
      <span class="news_comment_praise_count " :class="'news_comment_praise_count_discuss_' + item.discussID"
            v-show="item.praiseCount && item.praiseCount>0">{{item.praiseCount|parseCount}}</span>
    </div>
    <div v-if="isDetail == 3" class="news_comment_operation_3 news_comment_operation_3_new">

      <div v-if="showCommentBanner==1" class="commentBanner">
        <span class="news_comment_praise_span_count cursor" :class="item.curClass" @click="clickPares(item.curClass == 'news_comment_praise_img_active'? '' : item,1)">{{item.praiseCount && item.praiseCount>0 && (item.praiseCount | parseCount) +'&nbsp'  || ''}}赞</span>
        <span class="comment-m">|</span>
        <span class="comment-r cursor" @click="clickShowPopover()" >评论</span>
      </div>
      <img @click="clickShowCommentBanner()" class="cursor" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAP1BMVEUAAACZmZmampqZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiampqXl5efn5+ZmZk3xg50AAAAFHRSTlMA8SrYsvfrrZaPIgwHu9WmUlEsELeTK80AAADFSURBVFjD7ZZLDoMwDERth09CIIWQ+5+1Gmi7KUUiXrSq/BZBs/BDwSyGDOOJBNeWi7QuCO2MvlTix21+KtVMMPiiwBMJnm6OdJE4O0wKBcyvVMEKQyCcC1Wx4N2E/UWqImKbhItQJZg1gQn+VCA9cz+8UvOW5FwgjNwNnxPLqaApG7ejNO2pORVw2ej21B4lVgvUV1B/RO0af/5PNIEJviPQFgzWVpxEAaemZOXqmpcwmbVFU1919WUb5JC4XIRTyGQYD+6af0baPnzroAAAAABJRU5ErkJggg==" alt="">
    </div>
    <div v-if="isDetail != 3 && isDetail != 9" class="news_comment_operation_3">
      <span class="news_comment_praise_count comment_new" :class="'news_comment_praise_count_' + item.commentID"
            v-show="item.countPraise && item.countPraise>0">{{item.countPraise|parseCount}}</span>
      <svg @click="clickPares(item.curClass == 'news_comment_praise_img_active'? '' : item)"
           class="news_comment_praise_img"
           :class="item.curClass" version="1.1"
           xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
           y="0px"
           viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                 <g>
                                      <path d="M29.2,10.5c-1.2-0.3-4.2-0.3-8.5-0.4c0.2-0.9,0.2-1.8,0.2-3.3C20.9,3.2,18.3,0,16,0c-1.6,0-3,1.3-3,3
                                          c0,2-0.6,5.5-4,7.3c-0.2,0.1-1,0.5-1.1,0.5H8C7.5,10.3,6.7,10,6,10H3c-1.7,0-3,1.3-3,3v16c0,1.7,1.3,3,3,3h3c1.2,0,2.2-0.7,2.7-1.7
                                          l0,0c0.1,0,0.1,0,0.2,0.1l0,0c0.6,0.1,1.7,0.4,4.1,1c0.5,0.1,3.2,0.7,6,0.7h5.5c1.7,0,2.9-0.6,3.6-1.9c0,0,0.2-0.5,0.4-1.1
                                          c0.1-0.5,0.2-1.1,0-1.8c1.1-0.7,1.4-1.9,1.6-2.6c0.4-1.2,0.3-2.1,0-2.7c0.6-0.6,1.1-1.4,1.3-2.8c0.1-0.8,0-1.7-0.4-2.4
                                          c0.6-0.6,0.8-1.4,0.9-2.2v-0.2c0-0.1,0-0.2,0-0.5C32,12.6,31.1,11,29.2,10.5z M7,29c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V13
                                          c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1V29z M30,14.5c0,0.5-0.2,1.5-2,1.5c-1.5,0-2,0-2,0c-0.3,0-0.5,0.2-0.5,0.5S25.7,17,26,17
                                          c0,0,0.4,0,1.9,0s1.7,1.2,1.6,1.8C29.4,19.5,29,21,27.3,21s-2.4,0-2.4,0c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5c0,0,1.2,0,2,0
                                          c1.7,0,1.5,1.3,1.3,2.1c-0.3,1-0.5,1.9-2.6,1.9c-0.7,0-1.6,0-1.6,0c-0.3,0-0.5,0.2-0.5,0.5S23.7,27,24,27c0,0,0.7,0,1.6,0
                                          c1.1,0,1.1,1,1,1.4s-0.3,0.7-0.3,0.7C26,29.7,25.5,30,24.5,30H19c-2.7,0-5.5-0.6-5.5-0.6c-4.2-1-4.4-1-4.6-1.1c0,0-0.8-0.1-0.8-0.9
                                          V13.6c0-0.5,0.3-0.9,0.8-1c0.1,0,0.1,0,0.2-0.1c4.6-1.9,6-6,6-9.4c0-0.5,0.4-1,1-1c1.1,0,2.9,2.1,2.9,4.7c0,2.4-0.1,2.8-0.9,5.3
                                          c10,0,9.9,0.1,10.8,0.4c1.1,0.3,1.2,1.2,1.2,1.5C30,14.2,30,14.2,30,14.5z M32,32H0H32V0V32z"/>
                                  </g>
          </svg>


    </div>
  </div>
</template>

<script>
  import submit from '../../tool/submit'
  import $ from 'jquery'
  import utils from '../../tool/utils'

  export default {
    name: 'commentOperation',
    props: ['item', 'isDetail'],
    data () {
      return {
        sid: this.$route.params.sid,
        showCommentBanner: 0
      }
    },
    methods: {
      clickPares: function (item, n) {
        if (!item) return
        var id = n ? item.discussID : item.commentID
        if ((localStorage.getItem('topicDiscussPraise') || '').indexOf(id) > -1 || (localStorage.getItem('topicCommentPraise') || '').indexOf(id) > -1) return
        var _this = this
        var data = {
          sid: _this.sid
        }

        if (n) {
          data.uid = 0
          data.discussID = id
        } else {
          data.type = 1
          data.eventType = 2
          data.id = id
        }

        submit.clickPraise(data, n).then((res) => {
          if (res && res.data) {
            if (n) {
              // 参与评论点赞数
              if ((localStorage.getItem('topicDiscussPraise') || '').indexOf(id) === -1) {
                localStorage.setItem('topicDiscussPraise', (localStorage.getItem('topicDiscussPraise') || '') + '_' + id)
              }
              item.praiseCount = res.data.praiseCount
              item.commentCount = res.data.commentCount
              item.curClass = 'news_comment_praise_img_active'
              if (item.praiseCount > 0) {
                $('.news_comment_praise_count_discuss_' + id).text(res.data.praiseCount).show()
              }
              if (item.commentCount > 0) {
                $('.no_news_comment_praise_count_discuss_' + id).text(res.data.commentCount).show()
              }

            } else {
              $('.news_comment_praise_img_' + id).addClass('news_comment_praise_img_active')
              $('.news_comment_praise_count_' + id).text(res.data.countPraise)
              // 评论点赞数
              if ((localStorage.getItem('topicCommentPraise') || '').indexOf(id) === -1) {
                localStorage.setItem('topicCommentPraise', (localStorage.getItem('topicCommentPraise') || '') + '_' + id)
              }
              item.countPraise = res.data.countPraise
              item.curClass = 'news_comment_praise_img_active'
            }
          }
        }).catch((err) => {
          console.log('clickPares-result-err', err)
        })
      },
      clickShowPopover: function () {
        this.$emit('detailShowPopover')
      },
      clickShowCommentBanner: function () {
        this.showCommentBanner = !this.showCommentBanner
      }
    },
    filters: {
      parseCount: function (t) {
        if (!t) return
        return utils.parseCount(t)
      }
    }
  }
</script>

<style scoped>


  .news_comment_operation, .news_comment_operation div {
    /*display: flex;*/
    /*align-items: center;*/
    /*height: 0.5rem;*/
    line-height: 0.5rem;
    margin: 0;
    overflow: hidden;
  }
  .news_comment_operation_new, .news_comment_operation_new div{
    overflow: initial;
  }

  .news_comment_operation svg {
    display: inline-block;
    padding: 0;
    height: 0.3rem;
    width: 0.3rem;
    fill: #999999;
    margin: 0 0.1rem;
    vert-align: middle;
  }

  .news_comment_operation .list-praise {
    margin-right: 0.2rem;
  }

  .news_comment_operation .message {
    width: 0.36rem;
    height: 0.3rem;
    margin-right: 0;
  }

  .news_comment_operation .news_comment_praise_img_active {
    fill: var(--themeColor);
  }
  .news_comment_praise_img_active+.news_comment_praise_count{
    color: var(--themeColor);
  }

  .news_comment_praise_count {

    display: inline-block;
    padding: 0;
    color: #999999;
    line-height: normal;
    /*line-height: 15px;*/
    /*font-size: 13px;*/
    /*height: 15px;*/
    /*line-height: 0.3rem;*/
    font-size: 0.2rem;
    height: 0.3rem;
    padding-top: 0.035rem;
    line-height: 0.3rem;
    font-size: 0.28rem;
    height: 0.3rem;
  }
  .news_comment_operation_3 *{
    float: right;
  }

  .comment_new {
    line-height: 0.3rem;
    font-size: 0.28rem;
    height: 0.3rem;
  }
  .news_comment_operation_3_new{
    position: relative;

  }
  .news_comment_operation_3_new *{
    float: initial;
  }
  .news_comment_operation_3_new>img{
    display: block;
    width: 0.32rem;
    //height: 0.24rem;
  }
  .news_comment_operation_3_new .commentBanner{
    position: absolute;
    right: 24px;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 0.22rem;
    background: #F6F6F6;
    border-radius: 2px;
    padding: 0.04rem 0.1rem;
    line-height: 1;
    min-width: 1.1rem;
    white-space: nowrap;

  }
  .comment-m{
    margin: 0 2px;
  }
  .news_comment_operation_3_new .commentBanner:after{
    content: '';
    display: block;
    width: 0;
    height: 0;
    border: 0.1rem solid transparent;
    border-left-color: #F6F6F6;
    position: absolute;
    right: -0.18rem;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: -1;

  }
  .cursor{
    cursor: pointer;
  }

  .news_comment_praise_span_count.news_comment_praise_img_active{
      color: var(--themeColor);
  }

</style>



// WEBPACK FOOTER //
// commentOperation.vue?78f84fb6